export default __webpack_public_path__ + "media/images/features/saga/hishi-fc5e7e82c84450aa93e44dc30eb44cde.jpg";